module.exports = __webpack_public_path__ + "VN.png?ea2caec2f4b2e980f83534bd2a848240";